import { render } from "./Events1.vue?vue&type=template&id=51c25186"
import script from "./Events1.vue?vue&type=script&lang=js"
export * from "./Events1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__